namespace Gamification.Gamification {
    export interface AziendeRow {
        UserId?: number;
        TenantId?: number;
        IdAzienda?: number;
        RagioneSociale?: string;
    }

    export namespace AziendeRow {
        export const idProperty = 'IdAzienda';
        export const nameProperty = 'RagioneSociale';
        export const localTextPrefix = 'Gamification.Aziende';
        export const lookupKey = 'Gamification.Aziende';

        export function getLookup(): Q.Lookup<AziendeRow> {
            return Q.getLookup<AziendeRow>('Gamification.Aziende');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdAzienda = "IdAzienda",
            RagioneSociale = "RagioneSociale"
        }
    }
}
